import { LinearProgress, Stack } from '@mui/material';
import { OverageExceeded } from '@vy/ui-design-system';
import { percentage } from '@vy/utils';
import { FC } from 'react';

type LabelPlacement = 'top' | 'bottom';

type VyLinearProgressProps = {
  currentValue: number;
  totalValue: number;
  progressColor?: string;
  progressHeight?: number | string;
  renderLabel?: (percentage: number) => React.ReactNode;
  labelPlacement?: LabelPlacement;
};

export const VyLinearProgress: FC<VyLinearProgressProps> = ({
  currentValue,
  totalValue,
  progressColor,
  progressHeight = '6px',
  renderLabel,
  labelPlacement,
}) => {
  const calculatedPercentage = percentage(currentValue, totalValue);
  const isOverage = calculatedPercentage > 100;
  const direction = getFlexContainerDirection(labelPlacement);

  return (
    <Stack sx={{ flexDirection: direction, gap: 1 }}>
      {renderLabel?.(calculatedPercentage)}
      {isOverage ? (
        <OverageExceeded style={{ marginTop: '2px' }} />
      ) : (
        <LinearProgress
          variant="determinate"
          value={calculatedPercentage}
          sx={{
            height: progressHeight,
            marginTop: '2px',
            borderRadius: '12px',
            backgroundColor: '#0D1B270F',
            '& .MuiLinearProgress-bar': {
              backgroundColor: progressColor,
              borderRadius: 1,
            },
          }}
        />
      )}
    </Stack>
  );
};

function getFlexContainerDirection(labelPlacement?: LabelPlacement) {
  if (labelPlacement === 'bottom') {
    return 'column-reverse';
  }

  return 'column';
}
